window.EOMChatbotRules = {
  intents: [
    {
      id: "minor_age",
      priority: 100,
      keywords: [
        "minor",
        "under 18",
        "underage",
        "teen",
        "teenager",
        "child",
        "kid",
        "not 18",
        "17",
        "16"
      ],
      reply: {
        text:
          "EarthOnMall nicotine replacement products are not sold to minors. These products are intended for adults. If you have questions about safe use or eligibility, please ask a healthcare professional.",
        links: [
          { label: "Product Safety", urlKey: "productSafety" },
          { label: "Contact Support", urlKey: "contact" }
        ]
      }
    },
    {
      id: "medical_safety",
      priority: 95,
      keywords: [
        "pregnant",
        "pregnancy",
        "breastfeeding",
        "breast feeding",
        "heart",
        "blood pressure",
        "medication",
        "medicine",
        "side effect",
        "reaction",
        "allergic",
        "overdose",
        "too much nicotine",
        "can i combine",
        "combine patch",
        "patch and gum",
        "patch with gum",
        "patch and lozenge",
        "medical condition",
        "doctor",
        "nurse",
        "pharmacist"
      ],
      reply: {
        text:
          "I can help with product information and shopping guidance, but I cannot give medical advice. Please read and follow the exact product label. Do not combine nicotine products unless the label allows it or a healthcare professional recommends it.",
        links: [
          { label: "Product Safety", urlKey: "productSafety" },
          { label: "Contact Support", urlKey: "contact" }
        ]
      }
    },
    {
      id: "track_order",
      priority: 80,
      keywords: [
        "track",
        "tracking",
        "where is my order",
        "order status",
        "my package",
        "shipment",
        "shipping confirmation"
      ],
      reply: {
        text:
          "The fastest place to check an order is the Track My Order page. If you still need help, include your order number, checkout email, shipping name, ZIP/postal code, and tracking number if available.",
        links: [
          { label: "Track My Order", urlKey: "tracking" },
          { label: "Contact Support", urlKey: "contact" }
        ],
        followups: [
          { label: "Package says delivered", action: "intent:delivered_missing" },
          { label: "Wrong address", action: "intent:wrong_address" },
          { label: "Create ticket", action: "flow:ticket" }
        ]
      }
    },
    {
      id: "delivered_missing",
      priority: 78,
      keywords: ["delivered", "not delivered", "missing package", "never arrived"],
      reply: {
        text:
          "If tracking says delivered but you do not have the package, first check nearby delivery areas, mailrooms, parcel lockers, building staff, neighbors, and household members. If it still has not arrived, contact the carrier and EarthOnMall support.",
        links: [
          { label: "Shipping & Returns", urlKey: "shippingReturns" },
          { label: "Contact Support", urlKey: "contact" }
        ],
        followups: [{ label: "Create ticket", action: "flow:ticket" }]
      }
    },
    {
      id: "wrong_address",
      priority: 78,
      keywords: ["wrong address", "change address", "address mistake", "incorrect address"],
      reply: {
        text:
          "Contact support as soon as possible. If the order has not shipped, the team may be able to help. Once a package is with the carrier, address changes may be limited.",
        links: [{ label: "Contact Support", urlKey: "contact" }],
        followups: [{ label: "Create ticket", action: "flow:ticket" }]
      }
    },
    {
      id: "returns_refunds",
      priority: 75,
      keywords: ["return", "refund", "exchange", "send back", "opened product"],
      reply: {
        text:
          "Returns may require support approval, especially for opened or restricted products. Please review the Shipping & Returns page before sending anything back. EarthOnMall highlights 60-day returns, but eligibility can depend on product type, condition, timing, and whether the item is opened or used.",
        links: [
          { label: "Shipping & Returns", urlKey: "shippingReturns" },
          { label: "Create Support Ticket", action: "flow:ticket" }
        ]
      }
    },
    {
      id: "damaged_wrong_missing",
      priority: 75,
      keywords: [
        "damaged",
        "broken",
        "leaking",
        "missing item",
        "wrong item",
        "incorrect item",
        "packing slip"
      ],
      reply: {
        text:
          "Please contact support with your order number and clear photos of the product, packaging, packing slip, and shipping label. Keep the packaging until support has reviewed the case.",
        links: [{ label: "Create Support Ticket", action: "flow:ticket" }]
      }
    },
    {
      id: "subscribe",
      priority: 70,
      keywords: [
        "subscribe",
        "subscription",
        "subscribe and save",
        "refill",
        "monthly",
        "skip",
        "pause",
        "cancel subscription"
      ],
      reply: {
        text:
          "Subscribe & Save lets you build one refill box with multiple eligible products on one schedule. You can start with the Subscribe & Save page, then contact support if you need account or subscription help.",
        links: [
          { label: "Subscribe & Save", urlKey: "subscribe" },
          { label: "Contact Support", urlKey: "contact" }
        ]
      }
    },
    {
      id: "bulk_savings",
      priority: 68,
      keywords: ["bulk", "discount", "coupon", "promo", "savings", "deal"],
      reply: {
        text:
          "Bulk savings start at 2 eligible boxes and are calculated at checkout. EarthOnMall also highlights Subscribe & Save options on eligible products. Discount codes may have expiration dates, product restrictions, order minimums, or combination limits.",
        links: [
          { label: "Shop NRT Products", urlKey: "shop" },
          { label: "Subscribe & Save", urlKey: "subscribe" }
        ]
      }
    },
    {
      id: "compare_types",
      priority: 65,
      keywords: [
        "patch vs gum",
        "gum vs lozenge",
        "patch or gum",
        "patch",
        "gum",
        "lozenge",
        "compare",
        "which product",
        "what should i buy"
      ],
      reply: {
        text:
          "Start with how you want support to fit your day: patches are commonly chosen for steady daily support, gum for flexible craving moments, and lozenges for discreet oral support without chewing. Always read and follow the exact product label.",
        links: [
          { label: "Compare Patch, Gum, Lozenge", urlKey: "compareTypes" },
          { label: "Find My Starting Point", urlKey: "startingPoint" }
        ],
        followups: [
          { label: "I want steady support", action: "intent:patches" },
          { label: "I want flexible support", action: "intent:gum" },
          { label: "I want discreet support", action: "intent:lozenges" }
        ]
      }
    },
    {
      id: "strength",
      priority: 63,
      keywords: [
        "2mg",
        "4mg",
        "7mg",
        "14mg",
        "21mg",
        "step 1",
        "step 2",
        "step 3",
        "strength",
        "dose",
        "dosage"
      ],
      reply: {
        text:
          "Strength depends on the product format and the exact label. Patches are often organized as 21mg, 14mg, and 7mg steps. Gum and lozenges commonly include 2mg and 4mg options. Please use the label on the exact product you buy as the source of truth.",
        links: [
          { label: "Strength Guide", urlKey: "strengthGuide" },
          { label: "Product Safety", urlKey: "productSafety" }
        ]
      }
    },
    {
      id: "shipping_returns",
      priority: 60,
      keywords: [
        "shipping",
        "delivery",
        "free delivery",
        "same day",
        "same-day",
        "carrier",
        "label created",
        "returns"
      ],
      reply: {
        text:
          "EarthOnMall highlights same-day dispatch, free delivery, and 60-day returns. Shipping options, delivery estimates, and eligibility details depend on the cart, destination, carrier, and checkout settings.",
        links: [
          { label: "Shipping & Returns", urlKey: "shippingReturns" },
          { label: "Track My Order", urlKey: "tracking" }
        ]
      }
    },
    {
      id: "safety",
      priority: 58,
      keywords: ["safety", "label", "directions", "warning", "children", "pets", "storage"],
      reply: {
        text:
          "Nicotine is addictive. Use nicotine replacement products only as directed, read the label before use, keep products away from children and pets, and ask a healthcare professional when unsure.",
        links: [{ label: "Product Safety", urlKey: "productSafety" }]
      }
    },
    {
      id: "brands",
      priority: 54,
      keywords: ["habitrol", "nicotrol", "quitine", "rugby", "brand"],
      reply: {
        text:
          "You can shop EarthOnMall by brand and compare available patches, gum, and lozenges by format, strength, flavor, count, and value.",
        links: [
          { label: "Habitrol", urlKey: "habitrol" },
          { label: "Nicotrol", urlKey: "nicotrol" },
          { label: "Quitine", urlKey: "quitine" },
          { label: "Rugby", urlKey: "rugby" }
        ]
      }
    },
    {
      id: "patches",
      priority: 52,
      keywords: ["steady support", "all day", "patches", "nicotine patch"],
      reply: {
        text:
          "Patches are commonly chosen for steady daily support and simple step-down routines. Common patch strengths include 21mg, 14mg, and 7mg, depending on the exact product label.",
        links: [
          { label: "Shop Patches", urlKey: "patches" },
          { label: "Patch Strength Guide", urlKey: "strengthGuide" }
        ]
      }
    },
    {
      id: "gum",
      priority: 52,
      keywords: ["flexible support", "craving", "gum", "chew"],
      reply: {
        text:
          "Gum is commonly chosen for flexible support during craving moments. Shop by strength, flavor, count, brand, and value, and follow the exact product directions.",
        links: [
          { label: "Shop Gum", urlKey: "gum" },
          { label: "Compare Options", urlKey: "compareTypes" }
        ]
      }
    },
    {
      id: "lozenges",
      priority: 52,
      keywords: ["discreet", "lozenge", "lozenges", "no chew", "dissolve"],
      reply: {
        text:
          "Lozenges are commonly chosen for discreet oral support without chewing. Shop by strength, flavor, count, brand, and value, and let them dissolve as directed by the label.",
        links: [
          { label: "Shop Lozenges", urlKey: "lozenges" },
          { label: "Compare Options", urlKey: "compareTypes" }
        ]
      }
    }
  ],
  flows: {
    product_finder: {
      id: "product_finder",
      intro:
        "I can point you to a starting path. This is shopping guidance, not medical advice. Which support style sounds most useful?",
      steps: [
        {
          id: "style",
          question: "Which support style sounds most useful?",
          options: [
            {
              label: "Steady daily support",
              value: "patch",
              reply:
                "Patches are often chosen for steady daily support and fewer decisions during the day.",
              next: "goal"
            },
            {
              label: "Flexible craving support",
              value: "gum",
              reply:
                "Gum is often chosen for flexible support when craving moments appear.",
              next: "goal"
            },
            {
              label: "Discreet no-chew support",
              value: "lozenge",
              reply:
                "Lozenges are often chosen for discreet oral support that dissolves slowly without chewing.",
              next: "goal"
            },
            {
              label: "I want guided help",
              value: "guide",
              reply:
                "The Find My Starting Point guide is the best place to compare options before shopping.",
              end: {
                links: [{ label: "Find My Starting Point", urlKey: "startingPoint" }]
              }
            }
          ]
        },
        {
          id: "goal",
          question: "What would you like to do next?",
          options: [
            {
              label: "Shop matching products",
              value: "shop",
              endByPrevious: {
                patch: [{ label: "Shop Patches", urlKey: "patches" }],
                gum: [{ label: "Shop Gum", urlKey: "gum" }],
                lozenge: [{ label: "Shop Lozenges", urlKey: "lozenges" }]
              }
            },
            {
              label: "Compare first",
              value: "compare",
              end: {
                links: [{ label: "Compare Patch, Gum, Lozenge", urlKey: "compareTypes" }]
              }
            },
            {
              label: "Help choosing strength",
              value: "strength",
              end: {
                links: [{ label: "Strength Guide", urlKey: "strengthGuide" }]
              }
            },
            {
              label: "Build refill box",
              value: "subscribe",
              end: {
                links: [{ label: "Subscribe & Save", urlKey: "subscribe" }]
              }
            }
          ]
        }
      ]
    },
    ticket: {
      id: "ticket",
      intro:
        "I can prepare a support request for EarthOnMall. Please do not include payment card numbers, passwords, Social Security numbers, or sensitive medical details.",
      fields: [
        { id: "name", label: "Your name", required: true },
        { id: "email", label: "Email", required: true },
        {
          id: "reason",
          label: "Reason",
          required: true,
          options: [
            "Order status / tracking",
            "Shipping issue",
            "Return or refund request",
            "Damaged, missing, or wrong item",
            "Product question",
            "NRT strength or product type question",
            "Subscribe & Save",
            "Account help",
            "Payment or discount issue",
            "Other"
          ]
        },
        { id: "order", label: "Order number, if available", required: false },
        { id: "zip", label: "Shipping ZIP/postal code, if order-related", required: false },
        { id: "message", label: "Message", required: true }
      ]
    }
  },
  fallback: {
    text:
      "I can help with EarthOnMall products, order tracking, shipping, returns, subscriptions, product safety, and support routing. Choose a quick option below or ask a site-related question.",
    quickActions: true
  }
};
